export default __webpack_public_path__ + "static/media/logo.12412c4c.svg";